<span class=" d-block mb-2 subtitle-1--weight-regular">Planning Your Next Event?</span>
<div class="let-us-help-you p-3 p-md-4 mb-5">
    <div class="refer-a-friend__left mr-0 mr-md-3">
        <div class="refer-a-friend__title mb-2 d-flex justify-content-between">
            <div>                            
                <i class="fas fa-calendar-check let-us-help-you__calendar mr-2"></i>
                <span>Let us help you!</span>
            </div>
            <button class="btn--paybee btn btn--schedule-now-dashboard" (click)="letUsHelpYouModalOpen()" id="scheduleNowTop">SCHEDULE NOW</button>
        </div>
        <div class="refer-a-friend__content body-2 mb-4 mb-md-0">
            <span>Feeling overwhelmed? Schedule calls with our team so we can help you prepare for your next <b>In-person</b>, <b>Virtual</b> or <b>Hybrid event</b>.</span>        </div>
    </div>
 </div>
